// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pricing-templates__selector .sk-select {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
